import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from '../shared/pipes/pipes.module';
import { UtilService } from '../shared/services/util.service';
import { StepDescriptionModule } from '../shared/components/step-description/step-description.module';
import { FreeEvaluationEndYearPage } from './free-evaluation-end-year.page';
import { FreeEvaluationEndYearService } from './free-evaluation-end-year.service';
import { ManageEvaluationEndYearPage } from './manage-evaluation-end-year/manage-evaluation-end-year.page';
import { QuestionTypesModule } from '../shared/components/question-types/question-types.module';
import { ExternalUserCreationModule } from '../shared/modals/external-user-creation/external-user-creation.module';
import { ExternalUserCreationComponent } from '../shared/modals/external-user-creation/external-user-creation.component';
import { ConceptsTableComponent } from '../shared/components/concepts-table/concepts-table.component';
import { FreeEvaluationUsersListModule } from 'src/app/shared/components/free-evaluation-users-list/free-evaluation-users-list.module';
import { TextAlertModalModule } from 'src/app/shared/modals/text-alert/text-alert-modal.module';
import { TextAlertModal } from 'src/app/shared/modals/text-alert/text-alert-modal.component';

const routes: Routes = [{
    path: '',
    component: FreeEvaluationEndYearPage
}, {
    path: ':cycleParticipantId/:userId',
    component: ManageEvaluationEndYearPage
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        FormsModule,
        ReactiveFormsModule,
        StepDescriptionModule,
        QuestionTypesModule,
        ExternalUserCreationModule,
        FreeEvaluationUsersListModule,
        TextAlertModalModule
    ],
    declarations: [
        FreeEvaluationEndYearPage,
        ManageEvaluationEndYearPage,
        ConceptsTableComponent
    ],
    providers: [
        FreeEvaluationEndYearService,
        UtilService
    ]
})
export class FreeEvaluationEndYearModule {
}
